export default __webpack_public_path__ + "static/media/chat.a331b494.svg";